import React, { useState } from "react";
import { motion } from "framer-motion";

import Inhaberin from "../assets/inhaberin.jpeg";
import Salon1 from "../assets/salon_1.jpeg";
import Salon2 from "../assets/salon_2.jpeg";
import Salon3 from "../assets/salon_3.jpeg";

const salonImages = [Salon1, Salon2, Salon3];

const About: React.FC = () => {
  const [currentImage, setCurrentImage] = useState(0);

  const nextImage = () => {
    setCurrentImage((prev) => (prev + 1) % salonImages.length);
  };

  const prevImage = () => {
    setCurrentImage((prev) => (prev - 1 + salonImages.length) % salonImages.length);
  };

  return (
    
    <div className="bg-[#FAF7F2] min-h-screen px-6 py-20">
      {/* Hero / Inhaberin */}
        <section className="max-w-5xl mx-auto flex flex-col md:flex-row items-center md:items-start gap-8 mb-16 text-center md:text-left">

          <img
            src={Inhaberin}
            alt="Inhaberin"
            className="
              w-40 h-40
              sm:w-52 sm:h-52
              md:w-64 md:h-64
              object-cover 
              object-top        /* Gesicht sichtbar halten */
              rounded-full 
              border-4 
              border-[#C7B9A5]
              mx-auto md:mx-0
            "
          />
        <div>
          <h1 className="text-4xl font-light text-[#7A6E62] mb-4">Mariam Cepeci</h1>
          <p className="text-[#8C8378] text-lg leading-relaxed">
            Schön, dass Sie uns gefunden haben!
            Mein Name ist Mariam Cepeci, ich bin die Inhaberin der Beautique Mariam, im Herzen Münchens.
            Mein beruflicher Werdegang begann in der Medizin-Branche, wo ich über 10 Jahre wertvolle Erfahrungen sammeln konnte. Diese Expertise nutze ich heute, um Beauty-Anwendungen mit einem ganzheitlichen Ansatz zu kombinieren, der die Hautgesundheit und das Wohlbefinden meiner Kunden in den Mittelpunkt stellt.
          </p>
        </div>
      </section>

      {/* Über den Salon */}
      <section className="max-w-4xl mx-auto mb-16">
        <h2 className="text-3xl font-light text-[#7A6E62] mb-4">Über unseren Salon</h2>
        <p className="text-[#8C8378] text-lg leading-relaxed">
         Unsere Wohlfühloase heißt jede Seele willkommen!
         Bei uns ist jeder herzlich eingeladen – unabhängig von Alter, Geschlecht oder Identität.
         In der Beautique Mariam freuen wir uns darauf, Dich mit unserer Expertise und unserem Handwerk zu begeistern.
         Wir setzen alles daran, wunderbare Menschen glücklich nach Hause zu schicken!
         Werde auch Du ein Teil davon – wir freuen uns auf Dich!
        </p>
      </section>

      {/* Modern, verteilte Bildplatzierung (statt Slideshow) */}
      <section className="max-w-6xl mx-auto">
        <h2 className="text-3xl font-light text-[#7A6E62] mb-6 text-center">Unser Salon</h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 items-start">
          {/* Großes Bild links (nimmt 2 Spalten auf Desktop) */}
          <motion.div
            className="md:col-span-2 row-span-2 overflow-hidden rounded-xl shadow-lg"
            whileHover={{ scale: 1.02 }}
            transition={{ duration: 0.3 }}
          >
            <img
              src={Salon1}
              alt="Salon groß"
              className="w-full h-[460px] md:h-[520px] object-cover"
            />
          </motion.div>

          {/* Zwei kleinere Bilder rechts oben */}
          <motion.div
            className="overflow-hidden rounded-xl shadow-md"
            whileHover={{ scale: 1.04 }}
            transition={{ duration: 0.3 }}
          >
            <img src={Salon2} alt="Salon 2" className="w-full h-52 md:h-56 object-cover" />
          </motion.div>

          {/* Rechtes großes mittleres Bild */}
          <motion.div
            className="overflow-hidden rounded-xl shadow-md md:col-span-1"
            whileHover={{ scale: 1.03 }}
            transition={{ duration: 0.3 }}
          >
            <img src={Salon3} alt="Salon 3" className="w-full h-56 md:h-[320px] object-cover" />
          </motion.div>
        </div>

        <p className="text-center text-[#8C8378] mt-6 max-w-3xl mx-auto">
          Ein moderner, heller Salon mit Liebe zum Detail — entspannende Atmosphäre, professionelle Ausstattung und hochwertige Behandlungen.
        </p>
      </section>
    </div>
  );
};

export default About;